class t extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M12.995 5.755h-3v-2.5a1.82 1.82 0 0 0-2-2H7.21a.755.755 0 0 0-.715.585v.06l-.5 3.17-1.77 2.685H.995v7h9.5c3.72 0 4.5-2.175 4.5-4v-3a1.82 1.82 0 0 0-2-2Zm-9 8h-2v-5h2v5Zm10-3c0 2.045-1.11 3-3.5 3h-5.5v-5.35l2-2.965.365-2.685.07-.5h.565c.72 0 1 .28 1 1v3.5h4c.72 0 1 .28 1 1v3Z" clip-rule="evenodd"></path></svg>';
  }
}
const e = "pi-thumbs-up";
customElements.get(e) || customElements.define(e, t);
export {
  t as default
};
